import BaseServices from './baseServices';
import api from '../common/api';
import { APIError } from '../constants/errorCode/system';

export default {
  add: async params => {
    try {
      const url = api.companyUsersAlertVoucher.add;
      const data = await BaseServices.postDataToken(url, params);
      return await data.json();
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  update: async params => {
    try {
      const url = api.companyUsersAlertVoucher.update.replace(':id', params.id);
      const data = await BaseServices.putDataToken(url, params);
      return await data.json();
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  }
};
